import { postRequest } from "@/utils/client/api";

const updateWorkflowStatus = async (status: string, workflowId: number) => {
  return postRequest("api/workflow/status", { status, workflowId });
};

export default updateWorkflowStatus;
